// eslint-disable-next-line import/prefer-default-export
export const accountsSelector = (state) => state.account.accounts

export const remarksSelector = (state) => state.account.remarks

export const carouselCurrentItemSelector = (state) => state.account.currentItem

export const isAccRefreshSelector = (state) => state.account.isAccRefresh

